import Modal from 'react-modal';
import btnX from '../../icon/x_button_bg.svg';
import { onToggleModal } from '../../utils/utils';

export const ConfirmModal = ({
  children,
  width,
  padding = 'p-[32px]',
  title,
  content,
  setIsOpen,
  isOpen,
  onClose,
  onConfirm,
  type,
}) => {
  return (
    <Modal
      isOpen={() => onToggleModal(setIsOpen)}
      shouldCloseOnOverlayClick={false}
      className={`${width} bg-white rounded-[8px]`}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          position: 'static',
          maxWidth: '100%',
          maxHeight: '100%',
          overflow: 'auto',
        },
      }}
    >
      <div className="w-full flex justify-end px-3 py-3 ">
        <button onClick={() => onToggleModal(setIsOpen)}>
          <img
            src={btnX}
            tabIndex="0"
            aria-label="닫기 버튼"
          />
        </button>
      </div>
      <div className={`${padding}`}>
        <div className="flex justify-center mb-[4px]">
          <p className="text-[24px] font-[450]">{title}</p>
        </div>
        <div className="mb-[20px] text-center font-[400]">{content}</div>
        {children}
        <div className="flex justify-center">
          {type === 'complete' ? (
            <button
              className="px-4 md:px-8 py-2 rounded-xl bg-[#36B37E] text-white text-[16px] leading-6 font-[350]"
              onClick={onClose}
              aria-label="확인 버튼"
            >
              확인
            </button>
          ) : type === 'modify' ? (
            <button
              className="px-4 md:px-8 py-2 rounded-xl bg-[#36B37E] text-white text-[16px] leading-6 font-[350]"
              onClick={onConfirm}
              aria-label="변경 버튼"
            >
              변경
            </button>
          ) : (
            <button
              className="px-4 md:px-8 py-2 rounded-xl bg-[#CE3426] text-white text-[16px] leading-6 font-[350]"
              onClick={onConfirm}
              aria-label="삭제 버튼"
            >
              삭제
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
